module.exports = __webpack_public_path__ + "static/media/hf_inferior_tri.3d833433.jpg";